import { Grid, Paper } from '@achieve/ascend'
import { Typography } from 'components/Contentful'
import { ANCHOR_POINTS, AchieveBadge } from 'components/AchieveBadge'

const ExampleStat = ({ label, value, testIdPrefix, fontWeight = 'bold' }) => (
  <Grid size={{ xs: 6 }}>
    <Typography
      content={label?.textContent}
      variant="bodySm"
      data-testid={`example-label-${testIdPrefix}`}
    />
    <Typography
      content={value?.textContent}
      variant="bodyLg"
      fontWeight={fontWeight}
      className={'text-white pt-2'}
      data-testid={`example-value-${testIdPrefix}`}
    />
  </Grid>
)

const PaperCardBadge = ({ badgeExample, exampleTitle, stats }) => {
  const topRow = stats.slice(0, 2)
  const bottomRow = stats.slice(2, 4)

  return (
    <Paper
      className={
        'text-center shadow-none blueGradient2 text-white rounded-[10px] relative z-2 mt-0 mb-8 mx-0 pt-12 pb-8 px-4 md:rounded-[20px] md:mt-0 md:mb-4 md:mx-0 md:px-8 py-12'
      }
      data-testid="example-container"
    >
      <AchieveBadge
        content={badgeExample?.mediaContent}
        height={70}
        width={70}
        anchor={ANCHOR_POINTS.RIGHT_TOP}
        translateX={-110}
        translateY={0}
      />
      <Grid container>
        <Grid size={{ xs: 12 }}>
          <Typography
            content={exampleTitle?.textContent}
            variant="bodySm"
            fontWeight="bold"
            data-testid="example-title"
            className={'pb-6'}
          />
        </Grid>
        <Grid container>
          {topRow.map((stat) => (
            <ExampleStat key={stat.testIdPrefix} {...stat} />
          ))}
        </Grid>
        <Grid
          container
          className={'mt-4 pt-4 border-t-neutral-150 border-t border-solid border-x-0 border-b-0'}
        >
          {bottomRow.map((stat) => (
            <ExampleStat key={stat.testIdPrefix} {...stat} />
          ))}
        </Grid>
      </Grid>
    </Paper>
  )
}

export { PaperCardBadge }
